import { isAppError } from "@/api/problems";

/**
 * The sentence a failure is shown as: the server's `message`, or nothing.
 *
 * Rachel, 24-09-2026: the backend writes every error, and this screen does not
 * rewrite one. No trace-id suffix, and no sentence of ours when the server
 * sent none.
 */
export function errorText(error: unknown): string | null {
  if (!isAppError(error)) return null;
  return error.serverMessage ?? null;
}
